<div class="tw-w-full">
    <h4 class="tw-mb-2 tw-text-base tw-font-semibold tw-text-gray-900">Recomendaciones</h4>
    <div class="tw-flex tw-flex-col tw-gap-3">
        <app-recommendation-widget
            [title]="'Vencimiento de Cupos'"
            [content]="
                'Los cupos serán liberados si no realizas el pago hasta el día siguiente de la inscripción, entonces otra persona podrá usar tu lugar'
            "
        >
        </app-recommendation-widget>

        <app-recommendation-widget
            [title]="'Verificación de Periodo Actual'"
            [content]="
                'Recuerda que debes verificar el periodo de la inscripción, debes estar atento a nuestras redes sociales y página web para enterarte de la fecha de apertura de inscripciones'
            "
        >
        </app-recommendation-widget>

        <app-recommendation-widget
            [title]="'Información extra'"
            [content]="
                'Algunas academias pueden tener condiciones especiales, se sugiere leer la información extra que aparece al escoger la academia.'
            "
        >
        </app-recommendation-widget>

        <app-recommendation-widget
            [title]="'Cambios y Devoluciones'"
            [content]="
                'Recuerda que no existen cambio ni devoluciones en este tipo de transacción, asi que procura escoger con cuidado antes de realizar los pagos.'
            "
        >
        </app-recommendation-widget>
    </div>
</div>
